import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";

export const userApi = createAsyncThunk("userApi", async (i) => {
  return await fetch(
    `https://678c15511a6b89b27a2c4c9a.mockapi.io/api/user/${i}`
  )
    .then((res) => res.json())
    .catch((err) => {
      console.log("Error: ", err);
      throw new Error("Error encountered");
    });
});

export const updateProfileApi = createAsyncThunk(
  "user/updateProfile",
  async (profileData, { rejectWithValue }) => {
    try {
      const response = await axios.put("/users/profile", profileData);
      return response.data;
    } catch (error) {
      console.error("Update profile API error:", error);
      if (error.response && error.response.data) {
        return rejectWithValue(
          error.response.data.message || "Failed to update profile"
        );
      }
      return rejectWithValue("Failed to update profile");
    }
  }
);
